import $ from "../jquery_global";

window.TraceProductSelect  = {
  handleFaoProductList: () => {
    $("#trace_product_fao_product_id").select2({
      minimumInputLength: 3,
      ajax: {
        url: "/admin/trace_products/fao_products",
        dataType: 'json',
        delay: 300,
        type: "GET",
        processResults: function (data) {
          return {
            results: data.fao_products_list
          }
        }
      }
    })
  },

  handleTraceProductCountries: () => {
    $("#trace_product_country_id").select2({
      minimumInputLength: 3,
      ajax: {
        url: "/admin/trace_products/countries",
        dataType: 'json',
        delay: 300,
        type: "GET",
        processResults: function (data) {
          return {
            results: data.countries
          }
        }
      }
    })
  },

  setDefaultFaoProduct: (id, text) => {
    var newOption = new Option(text, id, false, false)

    $('#trace_product_fao_product_id').append(newOption);
    $('#trace_product_fao_product_id').val(id);
    $('#trace_product_fao_product_id').trigger('change');
  },

  setDefaultTraceProductCountry: (id, text) => {
    var newOption = new Option(text, id, false, false)

    $('#trace_product_country_id').append(newOption);
    $('#trace_product_country_id').val(id);
    $('#trace_product_country_id').trigger('change');
  },
}
